export default {
  namespaced: true,
  profiles: {
    title: "perfil | perfis",
    description: "descrição",
    forced_layouts: "layouts forçados",
    session_time: "Tempo de sessão em horas",
    priority:"Prioridade de Controle PTZ",
    priority_helper:"Números mais baixos significam maior prioridade.",
    inactivity_lifetime: "Tempo limite de inatividade em minutos",
    clone_title: "Clonar perfil",
    new_name: "Novo nome",
    clone_success: "Perfil clonado com sucesso",
  },
};
